import { API } from "@/lib/site";

export const ADMIN_TOKEN_KEY = "wf_admin_token";

export function getToken() {
  return localStorage.getItem(ADMIN_TOKEN_KEY) || "";
}

export function setToken(token) {
  if (token) localStorage.setItem(ADMIN_TOKEN_KEY, token);
  else localStorage.removeItem(ADMIN_TOKEN_KEY);
}

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Etwas ist schiefgelaufen. Bitte versuche es erneut.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

async function tryRefresh() {
  const res = await fetch(`${API}/admin/refresh`, { method: "POST", credentials: "include" });
  if (!res.ok) return null;
  const data = await res.json();
  if (data.token) {
    setToken(data.token);
    return data.token;
  }
  return null;
}

export async function adminFetch(url, options = {}) {
  const opts = {
    ...options,
    credentials: "include",
    headers: { ...(options.headers || {}), Authorization: `Bearer ${getToken()}` },
  };
  let res = await fetch(`${API}${url}`, opts);
  if (res.status === 401 && !options._retried) {
    const token = await tryRefresh();
    if (token) {
      return adminFetch(url, { ...options, _retried: true, headers: { ...(options.headers || {}), Authorization: `Bearer ${token}` } });
    }
  }
  let data = null;
  try {
    data = await res.json();
  } catch {
    data = null;
  }
  if (!res.ok) {
    const err = new Error(formatApiErrorDetail(data?.detail));
    err.status = res.status;
    throw err;
  }
  return data;
}

export async function adminUpload(file) {
  const fd = new FormData();
  fd.append("file", file);
  const data = await adminFetch("/admin/upload", { method: "POST", body: fd });
  return data;
}

export const STATUS_LABELS = {
  neu: "Neu",
  kontaktiert: "Kontaktiert",
  termin: "Termin vereinbart",
  erledigt: "Erledigt",
  storniert: "Storniert",
};

export const STATUS_COLORS = {
  neu: "border-blue-500/40 bg-blue-500/10 text-blue-400",
  kontaktiert: "border-amber-500/40 bg-amber-500/10 text-amber-400",
  termin: "border-emerald-500/40 bg-emerald-500/10 text-emerald-400",
  erledigt: "border-zinc-500/40 bg-zinc-500/10 text-zinc-300",
  storniert: "border-rose-500/40 bg-rose-500/10 text-rose-400",
};
